var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3330_11299)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3330_11299)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.68637 3.9994L11.2934 1.3924C11.4809 1.20492 11.7352 1.09961 12.0004 1.09961C12.2655 1.09961 12.5198 1.20492 12.7074 1.3924L15.3144 3.9994H19.0004C19.2656 3.9994 19.5199 4.10475 19.7075 4.29229C19.895 4.47983 20.0004 4.73418 20.0004 4.9994V8.6854L22.6074 11.2924C22.7948 11.4799 22.9002 11.7342 22.9002 11.9994C22.9002 12.2646 22.7948 12.5189 22.6074 12.7064L20.0004 15.3134V18.9994C20.0004 19.2646 19.895 19.519 19.7075 19.7065C19.5199 19.894 19.2656 19.9994 19.0004 19.9994H15.3144L12.7074 22.6064C12.5198 22.7939 12.2655 22.8992 12.0004 22.8992C11.7352 22.8992 11.4809 22.7939 11.2934 22.6064L8.68637 19.9994H5.00037C4.73516 19.9994 4.4808 19.894 4.29327 19.7065C4.10573 19.519 4.00037 19.2646 4.00037 18.9994V15.3134L1.39337 12.7064C1.2059 12.5189 1.10059 12.2646 1.10059 11.9994C1.10059 11.7342 1.2059 11.4799 1.39337 11.2924L4.00037 8.6854V4.9994C4.00037 4.73418 4.10573 4.47983 4.29327 4.29229C4.4808 4.10475 4.73516 3.9994 5.00037 3.9994H8.68637ZM12.0004 14.9994C12.796 14.9994 13.5591 14.6833 14.1217 14.1207C14.6843 13.5581 15.0004 12.795 15.0004 11.9994C15.0004 11.2037 14.6843 10.4407 14.1217 9.87807C13.5591 9.31547 12.796 8.9994 12.0004 8.9994C11.2047 8.9994 10.4417 9.31547 9.87905 9.87807C9.31644 10.4407 9.00037 11.2037 9.00037 11.9994C9.00037 12.795 9.31644 13.5581 9.87905 14.1207C10.4417 14.6833 11.2047 14.9994 12.0004 14.9994Z",
    fill: "#1865C1"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3330_11299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3330_11299"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetBlue);
export default __webpack_public_path__ + "static/media/set-blue.a73c94a80f5a5d14e60f20a8fc029f50.svg";
export { ForwardRef as ReactComponent };